/**
 * @enum FONT_FAMILY
 * @type {{ARIAL_BLACK: string, CURSIVE: string, IMPACT: string, GEORGIA: string, ARIAL: string, MONOSPACE: string, LUCIDA_GRANDE: string, HELVETICA: string}}
 */
export const FONT_FAMILY = {
  ARIAL: 'ARIAL',
  ARIAL_BLACK: 'ARIAL_BLACK',
  CURSIVE: 'CURSIVE',
  GEORGIA: 'GEORGIA',
  IMPACT: 'IMPACT',
  MONOSPACE: 'MONOSPACE',
  GOOGLE_ANTON: 'GOOGLE_ANTON',
  GOOGLE_BEBAS_NEUE: 'GOOGLE_BEBAS_NEUE',
  GOOGLE_FREDOKA_ONE: 'GOOGLE_FREDOKA_ONE',
  GOOGLE_INCONSOLATA: 'GOOGLE_INCONSOLATA',
  GOOGLE_KALAM: 'GOOGLE_KALAM',
  GOOGLE_MULISH: 'GOOGLE_MULISH',
  GOOGLE_NEUCHA: 'GOOGLE_NEUCHA',
  GOOGLE_OPEN_SANS: 'GOOGLE_OPEN_SANS',
  GOOGLE_OSWALD: 'GOOGLE_OSWALD',
  GOOGLE_PERMANENT_MARKER: 'GOOGLE_PERMANENT_MARKER',
  GOOGLE_ROBOTO: 'GOOGLE_ROBOTO',
  GOOGLE_RUSSO_ONE: 'GOOGLE_RUSSO_ONE',
  GOOGLE_NOTO_SANS: 'GOOGLE_NOTO_SANS',
  GOOGLE_MONTSERRAT: 'GOOGLE_MONTSERRAT',
  GOOGLE_POPPINS: 'GOOGLE_POPPINS',
  GOOGLE_INTER: 'GOOGLE_INTER',
  GOOGLE_LATO: 'GOOGLE_LATO',
  GOOGLE_ROBOTO_CONDENSED: 'GOOGLE_ROBOTO_CONDENSED',
  GOOGLE_BARLOW_CONDENSED: 'GOOGLE_BARLOW_CONDENSED',
  GOOGLE_ARCHIVO: 'GOOGLE_ARCHIVO',
  GOOGLE_TEKO: 'GOOGLE_TEKO',
  GOOGLE_ORBITRON: 'GOOGLE_ORBITRON',
  GOOGLE_RIGHTEOUS: 'GOOGLE_RIGHTEOUS',
  GOOGLE_YATRA_ONE: 'GOOGLE_YATRA_ONE',
  GOOGLE_PLAYFAIR_DISPLAY: 'GOOGLE_PLAYFAIR_DISPLAY',
  GOOGLE_MERRIWEATHER: 'GOOGLE_MERRIWEATHER',
  GOOGLE_ROBOTO_SLAB: 'GOOGLE_ROBOTO_SLAB',
  GOOGLE_EB_GARAMOND: 'GOOGLE_EB_GARAMOND',
  GOOGLE_ALFA_SLAB_ONE: 'GOOGLE_ALFA_SLAB_ONE',
  GOOGLE_BODONI_MODA: 'GOOGLE_BODONI_MODA',
  GOOGLE_STARDOS_STENCIL: 'GOOGLE_STARDOS_STENCIL',
  GOOGLE_PRIDI: 'GOOGLE_PRIDI',
  GOOGLE_CHONBURI: 'GOOGLE_CHONBURI',
  GOOGLE_INSTRUMENT_SERIF: 'GOOGLE_INSTRUMENT_SERIF',
  GOOGLE_FRANK_RUHL_LIBRE: 'GOOGLE_FRANK_RUHL_LIBRE',
  GOOGLE_DANCING_SCRIPT: 'GOOGLE_DANCING_SCRIPT',
  GOOGLE_PACIFICO: 'GOOGLE_PACIFICO',
  GOOGLE_LOBSTER: 'GOOGLE_LOBSTER',
  GOOGLE_CAVEAT: 'GOOGLE_CAVEAT',
  GOOGLE_SHADOWS_INTO_LIGHT: 'GOOGLE_SHADOWS_INTO_LIGHT',
  GOOGLE_SATISFY: 'GOOGLE_SATISFY',
  GOOGLE_ALEX_BRUSH: 'GOOGLE_ALEX_BRUSH',
  GOOGLE_RUBIK_BUBBLES: 'GOOGLE_RUBIK_BUBBLES',
  GOOGLE_LUCKIEST_GUY: 'GOOGLE_LUCKIEST_GUY',
  GOOGLE_SYNCOPATE: 'GOOGLE_SYNCOPATE',
  GOOGLE_JULEE: 'GOOGLE_JULEE',
  GOOGLE_FREDERICKA_THE_GREAT: 'GOOGLE_FREDERICKA_THE_GREAT',
  GOOGLE_BOOGALOO: 'GOOGLE_BOOGALOO',
  GOOGLE_MOUNTAINS_OF_CHRISTMAS: 'GOOGLE_MOUNTAINS_OF_CHRISTMAS',
  GOOGLE_RALEWAY_DOTS: 'GOOGLE_RALEWAY_DOTS',
  GOOGLE_NOSIFER: 'GOOGLE_NOSIFER',
  GOOGLE_PRESS_START_2P: 'GOOGLE_PRESS_START_2P',
  GOOGLE_AUDIOWIDE: 'GOOGLE_AUDIOWIDE',
  GOOGLE_MONOTON: 'GOOGLE_MONOTON',
  GOOGLE_PIXELIFY_SANS: 'GOOGLE_PIXELIFY_SANS',
  GOOGLE_PIRATA_ONE: 'GOOGLE_PIRATA_ONE',
  GOOGLE_UNIFRAKTURMAGUNTIA: 'GOOGLE_UNIFRAKTURMAGUNTIA',
  GOOGLE_RYE: 'GOOGLE_RYE',
  GOOGLE_BUNGEE_INLINE: 'GOOGLE_BUNGEE_INLINE',
  GOOGLE_GEOSTAR: 'GOOGLE_GEOSTAR',
  GOOGLE_BUNGEE_SHADE: 'GOOGLE_BUNGEE_SHADE',
  GOOGLE_BLACK_OPS_ONE: 'GOOGLE_BLACK_OPS_ONE',
  GOOGLE_VAST_SHADOW: 'GOOGLE_VAST_SHADOW',
  GOOGLE_BANGERS: 'GOOGLE_BANGERS',
  GOOGLE_SHRIKHAND: 'GOOGLE_SHRIKHAND',
};

export const googleFontInfo = [
  {
    font: FONT_FAMILY.GOOGLE_ANTON,
    fontFamily: 'Anton, sans-serif',
    stylesheet: 'https://fonts.googleapis.com/css2?family=Anton&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_BEBAS_NEUE,
    fontFamily: `'Bebas Neue', sans-serif`,
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_FREDOKA_ONE,
    fontFamily: `Fredoka One', cursive`,
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Fredoka+One&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_INCONSOLATA,
    fontFamily: 'Inconsolata, cursive',
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Inconsolata:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_KALAM,
    fontFamily: 'Kalam, cursive',
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Kalam:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_MULISH,
    fontFamily: 'Mulish, sans-serif',
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,400;0,700;1,400&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_NEUCHA,
    fontFamily: 'Neucha, cursive',
    stylesheet: 'https://fonts.googleapis.com/css2?family=Neucha&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_OPEN_SANS,
    fontFamily: `'Open Sans', sans-serif`,
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;1,400&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_OSWALD,
    fontFamily: 'Oswald, sans-serif',
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Oswald:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_PERMANENT_MARKER,
    fontFamily: `'Permanent Marker', cursive`,
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_ROBOTO,
    fontFamily: 'Roboto, sans-serif',
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,700;1,400&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_RUSSO_ONE,
    fontFamily: `'Russo One', sans-serif`,
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Russo+One&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_OPEN_SANS,
    fontFamily: "'Open Sans', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_MONTSERRAT,
    fontFamily: "'Montserrat', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_POPPINS,
    fontFamily: "'Poppins', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_INTER,
    fontFamily: "'Inter', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_LATO,
    fontFamily: "'Lato', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_ROBOTO_CONDENSED,
    fontFamily: "'Roboto Condensed', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_NOTO_SANS,
    fontFamily: "'Noto Sans', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_BARLOW_CONDENSED,
    fontFamily: "'Barlow Condensed', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_ARCHIVO,
    fontFamily: "'Archivo', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_TEKO,
    fontFamily: "'Teko', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Teko:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_ORBITRON,
    fontFamily: "'Orbitron', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_RIGHTEOUS,
    fontFamily: "'Righteous', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Righteous&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_YATRA_ONE,
    fontFamily: "'Yatra One', sans-serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Yatra+One&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_PLAYFAIR_DISPLAY,
    fontFamily: "'Playfair Display', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_MERRIWEATHER,
    fontFamily: "'Merriweather', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_ROBOTO_SLAB,
    fontFamily: "'Roboto Slab', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_EB_GARAMOND,
    fontFamily: "'EB Garamond', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_ALFA_SLAB_ONE,
    fontFamily: "'Alfa Slab One', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Alfa+Slab+One&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_BODONI_MODA,
    fontFamily: "'Bodoni Moda', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_STARDOS_STENCIL,
    fontFamily: "'Stardos Stencil', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Stardos+Stencil:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_PRIDI,
    fontFamily: "'Pridi', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Pridi:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_CHONBURI,
    fontFamily: "'Chonburi', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Chonburi&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_INSTRUMENT_SERIF,
    fontFamily: "'Instrument Serif', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_FRANK_RUHL_LIBRE,
    fontFamily: "'Frank Ruhl Libre', serif",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Frank+Ruhl+Libre:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_DANCING_SCRIPT,
    fontFamily: "'Dancing Script', cursive",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_PACIFICO,
    fontFamily: "'Pacifico', cursive",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Pacifico&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_LOBSTER,
    fontFamily: "'Lobster', cursive",
    stylesheet: 'https://fonts.googleapis.com/css2?family=Lobster&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_CAVEAT,
    fontFamily: "'Caveat', cursive",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Caveat:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_SHADOWS_INTO_LIGHT,
    fontFamily: "'Shadows Into Light', cursive",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Shadows+Into+Light&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_SATISFY,
    fontFamily: "'Satisfy', cursive",
    stylesheet: 'https://fonts.googleapis.com/css2?family=Satisfy&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_ALEX_BRUSH,
    fontFamily: "'Alex Brush', cursive",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Alex+Brush&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_RUBIK_BUBBLES,
    fontFamily: "'Rubik Bubbles', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Rubik+Bubbles&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_LUCKIEST_GUY,
    fontFamily: "'Luckiest Guy', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Luckiest+Guy&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_SYNCOPATE,
    fontFamily: "'Syncopate', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Syncopate:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_JULEE,
    fontFamily: "'Julee', fantasy",
    stylesheet: 'https://fonts.googleapis.com/css2?family=Julee&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_FREDERICKA_THE_GREAT,
    fontFamily: "'Fredericka the Great', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Fredericka+the+Great&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_BOOGALOO,
    fontFamily: "'Boogaloo', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Boogaloo&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_MOUNTAINS_OF_CHRISTMAS,
    fontFamily: "'Mountains of Christmas', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Mountains+of+Christmas:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_RALEWAY_DOTS,
    fontFamily: "'Raleway Dots', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Raleway+Dots&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_NOSIFER,
    fontFamily: "'Nosifer', fantasy",
    stylesheet: 'https://fonts.googleapis.com/css2?family=Nosifer&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_PRESS_START_2P,
    fontFamily: "'Press Start 2P', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_AUDIOWIDE,
    fontFamily: "'Audiowide', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Audiowide&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_MONOTON,
    fontFamily: "'Monoton', fantasy",
    stylesheet: 'https://fonts.googleapis.com/css2?family=Monoton&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_PIXELIFY_SANS,
    fontFamily: "'Pixelify Sans', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Pixelify+Sans:wght@400;700&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_PIRATA_ONE,
    fontFamily: "'Pirata One', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Pirata+One&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_UNIFRAKTURMAGUNTIA,
    fontFamily: "'UnifrakturMaguntia', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=UnifrakturMaguntia&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_RYE,
    fontFamily: "'Rye', fantasy",
    stylesheet: 'https://fonts.googleapis.com/css2?family=Rye&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_BUNGEE_INLINE,
    fontFamily: "'Bungee Inline', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Bungee+Inline&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_GEOSTAR,
    fontFamily: "'Geostar', fantasy",
    stylesheet: 'https://fonts.googleapis.com/css2?family=Geostar&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_BUNGEE_SHADE,
    fontFamily: "'Bungee Shade', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Bungee+Shade&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_BLACK_OPS_ONE,
    fontFamily: "'Black Ops One', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Black+Ops+One&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_VAST_SHADOW,
    fontFamily: "'Vast Shadow', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Vast+Shadow&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_BANGERS,
    fontFamily: "'Bangers', fantasy",
    stylesheet: 'https://fonts.googleapis.com/css2?family=Bangers&display=swap',
  },
  {
    font: FONT_FAMILY.GOOGLE_SHRIKHAND,
    fontFamily: "'Shrikhand', fantasy",
    stylesheet:
      'https://fonts.googleapis.com/css2?family=Shrikhand&display=swap',
  },
];

/**
 * Gets the font-family property for a CardElementText based on its CardElementConfiguration.
 *
 * @param {Object} cardElementConfiguration The CardElementConfiguration.
 * @returns {*|undefined}
 */
export const getCardElementTextFontFamily = cardElementConfiguration => {
  const { font_family: fontFamily } = cardElementConfiguration ?? {};
  const googleFontDetails = googleFontInfo.find(x => x.font === fontFamily);

  return googleFontDetails?.fontFamily ?? fontFamily ?? undefined;
};

/**
 * Determines whether a FONT_FAMILY is Google Fonts.
 *
 * @param {FONT_FAMILY} fontFamily The FONT_FAMILY.
 * @returns {boolean}
 */
export const isGoogleFontFamily = fontFamily => {
  return !!fontFamily?.contains('GOOGLE_');
};

/**
 * @enum FONT_STYLE
 * @type {{ITALIC: string, NORMAL: string}}
 */
export const FONT_STYLE = {
  NORMAL: 'NORMAL',
  ITALIC: 'ITALIC',
};

/**
 * @enum TEXT_ALIGN
 * @type {{CENTER: string, LEFT: string, RIGHT: string}}
 */
export const TEXT_ALIGN = {
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  RIGHT: 'RIGHT',
};

/**
 * @enum TEXT_TRANSFORM
 * @type {{CAPITALIZE: string, UPPERCASE: string, LOWERCASE: string, NONE: string}}
 */
export const TEXT_TRANSFORM = {
  CAPITALIZE: 'CAPITALIZE',
  UPPERCASE: 'UPPERCASE',
  LOWERCASE: 'LOWERCASE',
  NONE: 'NONE',
};

export const COMMON_PRESETS = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  FULL_NAME: 'Full Name',
  AGE: 'Age',
  TEAM: 'Team',
  YEAR: 'Year',
  SEASON: 'Season',
};

export const TEXT_PRESETS = {
  GALLERY_NAME_INSERT: '{gallery_name_insert}',
  ALBUM_NAME_INSERT: '{album_name_insert}',
  TEAM_LEVEL_INSERT: '{team_level_insert}',
  TEAM_NAME_INSERT: '{team_name_insert}',
  FULL_NAME_INSERT: '{full_name_insert}',
  FIRST_NAME_INSERT: '{first_name_insert}',
  LAST_NAME_INSERT: '{last_name_insert}',
  YEAR_INSERT: '{year_insert}',
};

export const TEXT_PRESET_LABELS = {
  [TEXT_PRESETS.GALLERY_NAME_INSERT]: 'Event Name',
  [TEXT_PRESETS.ALBUM_NAME_INSERT]: 'Event Name',
  [TEXT_PRESETS.TEAM_LEVEL_INSERT]: 'Team Level',
  [TEXT_PRESETS.TEAM_NAME_INSERT]: 'Team Name',
  [TEXT_PRESETS.FULL_NAME_INSERT]: 'Full Name',
  [TEXT_PRESETS.FIRST_NAME_INSERT]: 'First Name',
  [TEXT_PRESETS.LAST_NAME_INSERT]: 'Last Name',
  [TEXT_PRESETS.YEAR_INSERT]: 'Year',
};
